@if (selectedKind() === 'none') {
  <mat-card class="connect-card inspector-card">
    <mat-card-header>
      <div class="header-row">
        <p class="connect-section-title">Inspector</p>
        <button mat-button type="button" class="fullscreen-toggle" (click)="toggleFullscreen()">Fullscreen</button>
      </div>
    </mat-card-header>
    <mat-card-content>
        <p class="connect-muted">Select a node, edge, or section to inspect.</p>
    </mat-card-content>
  </mat-card>
} @else {
  @if (!isFullscreen()) {
    <div class="resize-handle" aria-hidden="true" (mousedown)="startResize($event)"></div>
  }

  @if (isFullscreen()) {
    <div class="fullscreen-shell">
      <header class="fullscreen-header">
        <div>
          <p class="connect-section-title">Inspector</p>
          @if (selectedKind() === 'node') {
            <p class="connect-muted">Node • {{ selectedNode()?.type }} • {{ selectedNode()?.id }}</p>
          } @else if (selectedKind() === 'edge') {
            <p class="connect-muted">Edge • {{ selectedEdge()?.source }} → {{ selectedEdge()?.target }}</p>
          } @else {
              <p class="connect-muted">Section • {{ selectedBackground()?.label || selectedBackground()?.id }}</p>
          }
        </div>
          <button (click)="toggleFullscreen()" color="primary" mat-stroked-button type="button">Close</button>
      </header>

      @if (selectedKind() === 'node') {
        <div class="fullscreen-grid">
          <section class="panel panel--settings">
            <p class="panel__title">Settings</p>
            <ng-container [ngTemplateOutlet]="nodeSettings"></ng-container>
          </section>

          <section class="panel panel--input">
            <p class="panel__title">Context input</p>
            <ng-container [ngTemplateOutlet]="runsPanel" [ngTemplateOutletContext]="{mode: 'input'}"></ng-container>
          </section>

          <section class="panel panel--output">
            <div class="panel__row">
              <p class="panel__title">Output</p>
              <button
                mat-flat-button
                color="primary"
                type="button"
                class="simulate-button"
                [disabled]="!workflowId() || selectedNodeType() !== 'control.loop' || typeof selectedRunInput() === 'undefined'"
                (click)="simulateSelectedNode()"
              >
                Simulate
              </button>
            </div>
            <ng-container [ngTemplateOutlet]="runsPanel" [ngTemplateOutletContext]="{mode: 'output'}"></ng-container>
          </section>
        </div>
      } @else if (selectedKind() === 'edge') {
        <section class="panel panel--edge-full">
          <p class="panel__title">Edge settings</p>
          <ng-container [ngTemplateOutlet]="edgeSettings"></ng-container>
        </section>
      } @else {
          <section class="panel panel--edge-full">
              <p class="panel__title">Section settings</p>
              <ng-container [ngTemplateOutlet]="backgroundSettings"></ng-container>
          </section>
      }
    </div>
  } @else {
    <mat-card class="connect-card inspector-card">
      <mat-card-header>
        <div class="header-row">
          <div>
            <p class="connect-section-title">Inspector</p>
            @if (selectedKind() === 'node') {
              <p class="connect-muted">Node • {{ selectedNode()?.type }}</p>
            } @else if (selectedKind() === 'edge') {
                <p class="connect-muted">Edge • {{ selectedEdge()?.source }} → {{ selectedEdge()?.target }}</p>
            } @else {
                <p class="connect-muted">Section • {{ selectedBackground()?.label || selectedBackground()?.id }}</p>
            }
          </div>
          <button mat-button type="button" class="fullscreen-toggle" (click)="toggleFullscreen()">Fullscreen</button>
        </div>
      </mat-card-header>

      <mat-card-content>
        @if (selectedKind() === 'node') {
          <mat-button-toggle-group
            class="tab-toggle"
            [value]="activeTab()"
            (change)="setActiveTab($any($event).value)"
            aria-label="Inspector tabs"
          >
            <mat-button-toggle value="settings">Settings</mat-button-toggle>
            <mat-button-toggle value="current">Current run</mat-button-toggle>
            <mat-button-toggle value="previous">Previous run</mat-button-toggle>
          </mat-button-toggle-group>

          @if (activeTab() === 'settings') {
            <ng-container [ngTemplateOutlet]="nodeSettings"></ng-container>
          } @else if (activeTab() === 'current') {
            <ng-container [ngTemplateOutlet]="runsPanel" [ngTemplateOutletContext]="{mode: 'current'}"></ng-container>
          } @else {
            <p class="connect-muted">Previous run details not available yet.</p>
          }
        } @else if (selectedKind() === 'edge') {
            <ng-container [ngTemplateOutlet]="edgeSettings"></ng-container>
        } @else {
            <ng-container [ngTemplateOutlet]="backgroundSettings"></ng-container>
        }
      </mat-card-content>
    </mat-card>
  }
}

<ng-template #nodeSettings>
  <div class="settings-stack">
    <p class="connect-subtitle">ID</p>
    <p class="connect-muted">{{ selectedNode()?.id }}</p>

    <p class="connect-subtitle">Label</p>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Label</mat-label>
      <input matInput type="text" [value]="selectedNode()?.label || ''" (input)="updateNodeLabel(($any($event.target).value || ''))" />
    </mat-form-field>

    <p class="connect-subtitle">Ref</p>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Operation ref</mat-label>
      <input matInput type="text" [value]="selectedNode()?.ref || ''" (change)="updateNodeRef(($any($event.target).value || ''))" />
    </mat-form-field>

    <div class="settings-row">
      <mat-form-field appearance="outline" class="half-width">
        <mat-label>On error</mat-label>
        <mat-select [value]="$any(selectedNode())?.['on_error'] || ''" (selectionChange)="updateNodeOnError($any($event).value)">
          <mat-option value="">(default)</mat-option>
          <mat-option value="fail">fail</mat-option>
          <mat-option value="continue">continue</mat-option>
          <mat-option value="retry">retry</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="half-width">
        <mat-label>Retries</mat-label>
        <input matInput type="number" min="0" [value]="$any($any(selectedNode())?.['retries'] ?? '')" (input)="updateNodeRetries(($any($event.target).value || ''))" />
      </mat-form-field>
    </div>

    <div class="settings-row">
      <mat-form-field appearance="outline" class="half-width">
        <mat-label>Timeout (ms)</mat-label>
        <input matInput type="number" min="1" [value]="$any($any(selectedNode())?.['timeout_ms'] ?? '')" (input)="updateNodeTimeout(($any($event.target).value || ''))" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="half-width">
        <mat-label>Idempotency key</mat-label>
        <input matInput type="text" [value]="$any($any(selectedNode())?.['idempotency_key'] ?? '')" (input)="updateNodeIdempotencyKey(($any($event.target).value || ''))" />
      </mat-form-field>
    </div>

    @if (selectedNodeType() === 'api.http' || selectedNodeType() === 'api') {
      <mat-divider></mat-divider>
      <p class="connect-subtitle">HTTP</p>
      <div class="settings-row">
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Method</mat-label>
          <mat-select [value]="$any($any(selectedNode())?.['input']?.method || 'GET')" (selectionChange)="updateHttpMethod($any($event).value)">
            @for (m of ['GET', 'POST', 'PUT', 'PATCH', 'DELETE']; track m) {
              <mat-option [value]="m">{{ m }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>URL</mat-label>
          <input matInput type="text" [value]="$any($any(selectedNode())?.['input']?.url || '')" (input)="updateHttpUrl(($any($event.target).value || ''))" />
        </mat-form-field>
      </div>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Headers (JSON)</mat-label>
        <textarea
          matInput
          rows="4"
          [value]="httpHeadersDraft()"
          (input)="setHttpHeadersDraft(($any($event.target).value || ''))"
          (blur)="applyHttpHeadersDraft()"
        ></textarea>
        @if (httpHeadersError()) {
          <mat-error>{{ httpHeadersError() }}</mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Body</mat-label>
        <textarea
          matInput
          rows="6"
          [value]="httpBodyDraft()"
          (input)="setHttpBodyDraft(($any($event.target).value || ''))"
          (blur)="applyHttpBodyDraft()"
        ></textarea>
        @if (httpBodyError()) {
          <mat-error>{{ httpBodyError() }}</mat-error>
        }
      </mat-form-field>
    }

    @if (selectedNodeType() === 'api.connector' || selectedNodeType() === 'action') {
      <mat-divider></mat-divider>
      <p class="connect-subtitle">Connector</p>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Connection</mat-label>
        <mat-select [value]="$any($any(selectedNode())?.['connection'] ?? '')" (selectionChange)="updateConnectorConnection($any($event).value)">
          <mat-option value="">(none)</mat-option>
          @for (opt of humanConnectionOptions(); track opt.value) {
            <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
          }
        </mat-select>
        @if (connectionsError()) {
          <mat-hint class="connect-muted">{{ connectionsError() }}</mat-hint>
        }
      </mat-form-field>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Object type (optional)</mat-label>
        <input matInput type="text" [value]="$any($any(selectedNode())?.['objectType'] ?? '')" (input)="updateConnectorObjectType(($any($event.target).value || ''))" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Input (JSON)</mat-label>
        <textarea
          matInput
          rows="6"
          [value]="inputJsonDraft()"
          (input)="setInputJsonDraft(($any($event.target).value || ''))"
          (blur)="applyInputJsonDraft()"
        ></textarea>
        @if (inputJsonError()) {
          <mat-error>{{ inputJsonError() }}</mat-error>
        }
      </mat-form-field>
    }

    @if (selectedNodeType().startsWith('trigger.') || (selectedNodeType() === 'manual_trigger' || selectedNodeType() === 'webhook_trigger' || selectedNodeType() === 'scheduled_trigger')) {
      <mat-divider></mat-divider>
      @if (isWebhookTriggerNode()) {
        <p class="connect-subtitle">Webhook call</p>
        <p class="connect-muted hint">
          Send a POST/PUT request to start a run. The request is available as <code>$.webhook</code> (body/query/headers)
          in conditions/transforms.
        </p>

        @if (!webhookUrl()) {
          <p class="connect-muted hint">Save the workflow to generate the webhook URL.</p>
        } @else {
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>URL (POST/PUT)</mat-label>
            <input matInput type="text" readonly [value]="webhookUrl()" />
            <button
              mat-icon-button
              matSuffix
              type="button"
              aria-label="Copy webhook URL"
              [disabled]="!webhookUrl()"
              (click)="copyToClipboard(webhookUrl(), 'Webhook URL copied')"
            >
              <mat-icon>content_copy</mat-icon>
            </button>
          </mat-form-field>

          <div class="settings-row">
            <button mat-stroked-button type="button" [disabled]="!webhookCurlSnippet()" (click)="copyToClipboard(webhookCurlSnippet(), 'cURL copied')">
              Copy cURL
            </button>
          </div>

          <pre class="json-block">{{ webhookCurlSnippet() }}</pre>

          <p class="connect-muted hint">
            Query params are captured under <code>$.webhook.query</code>, the JSON body under <code>$.webhook.body</code>,
            and only <code>Content-*</code> / <code>X-*</code> headers are stored (Authorization/Cookie excluded).
          </p>
        }
      }

      <p class="connect-subtitle">Trigger input</p>
      @if (isWebhookTriggerNode()) {
        <p class="connect-muted hint">
          This input is merged into <code>$.webhook</code> for every run. Incoming webhook requests overwrite
          <code>body</code>, <code>query</code>, and <code>headers</code>; keep defaults in <code>static</code>.
        </p>
      }
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Input (JSON)</mat-label>
        <textarea
          matInput
          rows="6"
          [value]="inputJsonDraft()"
          (input)="setInputJsonDraft(($any($event.target).value || ''))"
          (blur)="applyInputJsonDraft()"
        ></textarea>
        @if (inputJsonError()) {
          <mat-error>{{ inputJsonError() }}</mat-error>
        }
      </mat-form-field>
    }

    @if (selectedNodeType() === 'control.condition' || selectedNodeType() === 'condition') {
      <mat-divider></mat-divider>
      <p class="connect-subtitle">Condition</p>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Expression</mat-label>
        <input matInput type="text" [value]="$any($any(selectedNode())?.['condition']?.expression ?? '')" (input)="updateConditionExpression(($any($event.target).value || ''))" />
      </mat-form-field>
    }

    @if (selectedNodeType() === 'control.loop' || selectedNodeType() === 'loop') {
      <mat-divider></mat-divider>
      <p class="connect-subtitle">Loop</p>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Collection (JSONPath)</mat-label>
        <input matInput type="text" [value]="$any($any(selectedNode())?.['loop']?.collection ?? '')" (input)="updateLoopCollection(($any($event.target).value || ''))" />
      </mat-form-field>
      <div class="settings-row">
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Item alias</mat-label>
          <input matInput type="text" [value]="$any($any(selectedNode())?.['loop']?.item_alias ?? '')" (input)="updateLoopItemAlias(($any($event.target).value || ''))" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Concurrency</mat-label>
          <input matInput type="number" min="1" [value]="$any($any(selectedNode())?.['loop']?.concurrency ?? '')" (input)="updateLoopConcurrency(($any($event.target).value || ''))" />
        </mat-form-field>
      </div>
        <div class="settings-row">
            <mat-form-field appearance="outline" class="half-width">
                <mat-label>Max items</mat-label>
                <input (input)="updateLoopMaxItems(($any($event.target).value || ''))" [value]="$any($any(selectedNode())?.['loop']?.max_items ?? '')" matInput min="0"
                       type="number"/>
            </mat-form-field>
            <mat-form-field appearance="outline" class="half-width">
                <mat-label>Until (expression, optional)</mat-label>
                <input (input)="updateLoopUntil(($any($event.target).value || ''))" [value]="$any($any(selectedNode())?.['loop']?.until ?? '')" matInput
                       type="text"/>
            </mat-form-field>
        </div>
    }

    @if (selectedNodeType() === 'control.wait' || selectedNodeType() === 'wait') {
      <mat-divider></mat-divider>
      <p class="connect-subtitle">Wait</p>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Delay (ms)</mat-label>
        <input matInput type="number" min="0" [value]="$any($any(selectedNode())?.['wait']?.delay_ms ?? '')" (input)="updateWaitDelayMs(($any($event.target).value || ''))" />
      </mat-form-field>
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Until (ISO or expression)</mat-label>
            <input (input)="updateWaitUntil(($any($event.target).value || ''))" [value]="$any($any(selectedNode())?.['wait']?.until ?? '')" matInput
                   type="text"/>
        </mat-form-field>
    }

    @if (selectedNodeType() === 'control.transform' || selectedNodeType() === 'transform') {
      <mat-divider></mat-divider>
      <p class="connect-subtitle">Transform</p>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Language</mat-label>
        <mat-select [value]="$any($any(selectedNode())?.['transform']?.language ?? 'jq')" (selectionChange)="updateTransformLanguage($any($event).value)">
          @for (lang of ['jq', 'cel', 'jsonata', 'js', 'python']; track lang) {
            <mat-option [value]="lang">{{ lang }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Expression</mat-label>
        <textarea
          matInput
          rows="5"
          [value]="$any($any(selectedNode())?.['transform']?.expression ?? '')"
          (input)="updateTransformExpression(($any($event.target).value || ''))"
        ></textarea>
      </mat-form-field>
    }

    @if (selectedNodeType() === 'control.join' || selectedNodeType() === 'join') {
      <mat-divider></mat-divider>
      <p class="connect-subtitle">Join</p>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Strategy</mat-label>
        <mat-select [value]="$any($any(selectedNode())?.['join']?.strategy ?? 'all')" (selectionChange)="updateJoinStrategy($any($event).value)">
          @for (strategy of ['all', 'any', 'count', 'label']; track strategy) {
            <mat-option [value]="strategy">{{ strategy }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    @if (selectedNodeType().startsWith('ai.')) {
      <mat-divider></mat-divider>
      <p class="connect-subtitle">AI</p>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Instructions</mat-label>
        <textarea matInput rows="5" [value]="$any($any(selectedNode())?.['x-ai']?.instructions ?? '')" (input)="updateAiInstructions(($any($event.target).value || ''))"></textarea>
      </mat-form-field>
      <div class="settings-row">
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Model</mat-label>
          <input matInput type="text" [value]="$any($any(selectedNode())?.['x-ai']?.model ?? '')" (input)="updateAiModel(($any($event.target).value || ''))" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Max tokens</mat-label>
          <input
            matInput
            type="number"
            min="1"
            [value]="$any($any(selectedNode())?.['x-ai']?.max_tokens ?? '')"
            (input)="updateAiMaxTokens(($any($event.target).value || ''))"
          />
        </mat-form-field>
      </div>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Temperature</mat-label>
        <input
          matInput
          type="number"
          min="0"
          max="2"
          step="0.1"
          [value]="$any($any(selectedNode())?.['x-ai']?.temperature ?? '')"
          (input)="updateAiTemperature(($any($event.target).value || ''))"
        />
      </mat-form-field>
    }
  </div>
</ng-template>

<ng-template #edgeSettings>
  <div class="settings-stack">
    <p class="connect-subtitle">Label</p>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Label</mat-label>
      <input matInput type="text" [value]="selectedEdge()?.label || ''" (input)="updateEdgeLabel(($any($event.target).value || ''))" />
    </mat-form-field>

    <p class="connect-subtitle">Condition</p>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Condition expression</mat-label>
      <input matInput type="text" [value]="$any(selectedEdge()?.['condition'] ?? '')" (input)="updateEdgeCondition(($any($event.target).value || ''))" />
    </mat-form-field>

    <div class="settings-row">
      <mat-form-field appearance="outline" class="half-width">
        <mat-label>Priority</mat-label>
        <input matInput type="number" min="0" [value]="$any(selectedEdge()?.['priority'] ?? '')" (input)="updateEdgePriority(($any($event.target).value || ''))" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="half-width">
        <mat-label>On error</mat-label>
        <mat-select [value]="$any(selectedEdge()?.['on_error'] ?? '')" (selectionChange)="updateEdgeOnError($any($event).value)">
          <mat-option value="">(inherit)</mat-option>
          <mat-option value="fail">fail</mat-option>
          <mat-option value="continue">continue</mat-option>
          <mat-option value="retry">retry</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <p class="connect-muted hint">On error inherits workflow.settings.default_on_error when empty.</p>
  </div>
</ng-template>

<ng-template #backgroundSettings>
    <div class="settings-stack">
        <p class="connect-subtitle">ID</p>
        <p class="connect-muted">{{ selectedBackground()?.id }}</p>

        <p class="connect-subtitle">Label</p>
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Label</mat-label>
            <input
                    (input)="updateBackgroundLabel(($any($event.target).value || ''))"
                    [value]="selectedBackground()?.label || ''"
                    matInput
                    type="text"
            />
        </mat-form-field>

        <p class="connect-subtitle">Fill</p>
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Color</mat-label>
            <input
                    (input)="updateBackgroundColor(($any($event.target).value || ''))"
                    [value]="selectedBackground()?.style?.fill || ''"
                    matInput
                    placeholder="#e2e8f0"
                    type="text"
            />
        </mat-form-field>

        <div class="settings-row">
            <mat-form-field appearance="outline" class="half-width">
                <mat-label>Opacity</mat-label>
                <input
                        (input)="updateBackgroundOpacity(($any($event.target).value || ''))"
                        [value]="selectedBackground()?.style?.opacity ?? ''"
                        matInput
                        max="1"
                        min="0"
                        step="0.05"
                        type="number"
                />
            </mat-form-field>

            <mat-form-field appearance="outline" class="half-width">
                <mat-label>Radius</mat-label>
                <input
                        (input)="updateBackgroundRadius(($any($event.target).value || ''))"
                        [value]="selectedBackground()?.style?.radius ?? ''"
                        matInput
                        min="0"
                        step="1"
                        type="number"
                />
            </mat-form-field>
        </div>

        <p class="connect-subtitle">Size</p>
        <div class="settings-row">
            <mat-form-field appearance="outline" class="half-width">
                <mat-label>Width</mat-label>
                <input
                        (input)="updateBackgroundWidth(($any($event.target).value || ''))"
                        [value]="selectedBackground()?.size?.width ?? ''"
                        matInput
                        min="1"
                        step="10"
                        type="number"
                />
            </mat-form-field>

            <mat-form-field appearance="outline" class="half-width">
                <mat-label>Height</mat-label>
                <input
                        (input)="updateBackgroundHeight(($any($event.target).value || ''))"
                        [value]="selectedBackground()?.size?.height ?? ''"
                        matInput
                        min="1"
                        step="10"
                        type="number"
                />
            </mat-form-field>
        </div>

        <mat-slide-toggle
                (change)="updateBackgroundLocked($any($event).checked)"
                [checked]="selectedBackground()?.locked === true"
        >
            Locked
        </mat-slide-toggle>

        <p class="connect-muted hint">Tip: select the section, then drag its edges/corners on the canvas to resize.</p>

        <button (click)="deleteBackground()" color="warn" mat-stroked-button type="button">Delete section</button>
    </div>
</ng-template>

<ng-template #runsPanel let-mode="mode">
  <div class="runs-stack">
    @if (runsLoading()) {
      <div class="loading-row">
        <mat-progress-spinner diameter="22" mode="indeterminate"></mat-progress-spinner>
        <span class="connect-muted">Loading runs…</span>
      </div>
    }
    @if (runsError()) {
      <p class="connect-muted">{{ runsError() }}</p>
    }

    @if (runs() && (runs()!.length > 0)) {
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Run</mat-label>
        <mat-select [value]="selectedRunId()" (selectionChange)="setSelectedRunId($any($event).value)">
          <mat-option value="">Select run…</mat-option>
          @for (r of runs()!; track r.id) {
            <mat-option [value]="r.id">{{ r.id }} • {{ r.status }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    } @else if (!runsLoading()) {
      <p class="connect-muted">No runs found.</p>
    }

    @if (mode === 'input') {
      @if (typeof selectedRunInput() === 'undefined') {
        <p class="connect-muted">Select a run to preview context input.</p>
      } @else {
        <pre class="json-block">{{ formatJson(selectedRunInput()) }}</pre>
      }
    }

    @if (mode === 'output' || mode === 'current') {
      @if (selectedRunStatus()) {
        <span class="connect-chip neutral status-chip">{{ selectedRunStatus() }}</span>
      }
      @if (typeof selectedRunOutput() === 'undefined') {
        <p class="connect-muted">Select a run to preview output.</p>
      } @else {
        <pre class="json-block">{{ formatJson(selectedRunOutput()) }}</pre>
      }
    }
  </div>
</ng-template>
